import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { useAddValueChainMutation, useUpdateValueChainMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'AddValueChain',
  setup: function setup(__props) {
    var _useAddValueChainMuta = useAddValueChainMutation(),
      addValueChain = _useAddValueChainMuta.mutate,
      loading = _useAddValueChainMuta.loading;
    var _useUpdateValueChainM = useUpdateValueChainMutation(),
      editValueChain = _useUpdateValueChainM.mutate;
    var attrs = useAttrs();
    var name = ref(attrs === null || attrs === void 0 ? void 0 : attrs.name);
    var infoDialog = ref(false);
    return {
      __sfc: true,
      addValueChain: addValueChain,
      loading: loading,
      editValueChain: editValueChain,
      attrs: attrs,
      name: name,
      infoDialog: infoDialog
    };
  }
});